<template>
  <div class="home">
    <!-- 1. Hero Section -->
    <HeroSection />

    <!-- 2. Features Grid (核心優勢) -->
    <FeatureSection />

    <!-- 3. Detail Showcase (左右圖文) -->
    <ShowCaseSection />

    <!-- 4. Marketing Module (行銷工具) -->
    <MarketingSection />

    <!-- 5. CTA Section -->
    <CTASection />
  </div>
</template>

<script>
import HeroSection from "@/components/home/HeroSection.vue";
import FeatureSection from "@/components/home/FeatureSection.vue";
import ShowCaseSection from "@/components/home/ShowCaseSection.vue";
import MarketingSection from "@/components/home/MarketingSection.vue";
import CTASection from "@/components/home/CTASection.vue";
export default {
  name: "HomeView",
  components: {
    HeroSection,
    FeatureSection,
    ShowCaseSection,
    MarketingSection,
    CTASection,
  },
  mounted() {
    const observerOptions = { threshold: 0.1 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    }, observerOptions);

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
  },
};
</script>
